// src/components/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const ProtectedRoute = ({ children, role }) => {
  const { currentUser, loading } = useContext(AuthContext);

  // ⏳ Tunggu proses auth selesai
  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20%" }}>Loading...</div>
    );
  }

  // ❌ Belum login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // ❌ Role tidak sesuai
  if (role && currentUser.role !== role) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Aman render
  return children;
};

export default ProtectedRoute;
